<template>
  <div>
    <!-- 如果已登录，显示原来的Index内容 -->
    <index-view v-if="isLoggedIn" />
  </div>
</template>

<script>
import { isUserLoggedIn } from "@/utils/auth.js";
import IndexView from "@/views/Index.vue";

export default {
  name: "Home",
  components: {
    IndexView,
  },
  data() {
    return {
      isLoggedIn: false,
    };
  },
  created() {
    this.checkLoginStatus();
    // 监听登录状态变化
    this.startLoginStatusCheck();
  },
  
  mounted() {
    // 检查登录状态，如果未登录则重定向到登录页面
    this.checkAndRedirect();
  },
  methods: {
    checkLoginStatus() {
      this.isLoggedIn = isUserLoggedIn();
    },
    // 定期检查登录状态变化
    startLoginStatusCheck() {
      this.loginStatusInterval = setInterval(() => {
        const currentLoginStatus = isUserLoggedIn();
        if (currentLoginStatus !== this.isLoggedIn) {
          this.isLoggedIn = currentLoginStatus;
          // 如果登录状态变化，检查是否需要重定向
          this.checkAndRedirect();
        }
      }, 1000); // 每秒检查一次
    },
    
    // 检查登录状态并重定向
    checkAndRedirect() {
      if (this.isLoggedIn) {
        // 已登录，重定向到管理后台
        this.$router.push('/admin/dashboard');
      } else {
        // 未登录，重定向到登录页面
        this.$router.push('/auth/login');
      }
    },
  },
  // 监听路由变化，重新检查登录状态
  watch: {
    '$route'() {
      this.checkLoginStatus();
    }
  },
  // 清理定时器
  beforeUnmount() {
    if (this.loginStatusInterval) {
      clearInterval(this.loginStatusInterval);
    }
  }
};
</script>